import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("fn_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data.user))
      .catch(() => {
        localStorage.removeItem("fn_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = useCallback((token, u) => {
    localStorage.setItem("fn_token", token);
    setUser(u);
  }, []);
  const logout = useCallback(() => {
    localStorage.removeItem("fn_token");
    setUser(false);
  }, []);

  useEffect(() => {
    if (!user) return;
    let t;
    const doTimeout = () => {
      localStorage.removeItem("fn_token");
      setUser(false);
      toast("You've been signed out due to inactivity.");
    };
    const reset = () => { clearTimeout(t); t = setTimeout(doTimeout, 30 * 60 * 1000); };
    const evs = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    evs.forEach((e) => window.addEventListener(e, reset));
    reset();
    return () => { clearTimeout(t); evs.forEach((e) => window.removeEventListener(e, reset)); };
  }, [user]);

  const value = useMemo(() => ({ user, ready, login, logout, setUser }), [user, ready, login, logout]);
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
